// The deck designer's tabs, all kept in the URL: the form's, the results Card's and the preview's.
export const DECK_DESIGNER_TAB_PARAMETER = "deck_designer_tab";
export const BOARDS_FORM_TAB_INDEX = 1;

export const DECK_DESIGNER_RESULTS_TAB_PARAMETER = "deck_designer_results_tab";
export const RESULTS_TAB_INDEX = { preview: 0, billOfQuantities: 1, calculationDetails: 2 } as const;

export const DECK_DESIGNER_PREVIEW_TAB_PARAMETER = "deck_designer_preview_tab";
export const PREVIEW_TAB_INDEX = { plane: 0, section: 1, bottom: 2, slope: 3 } as const;

// The design-system Card takes no ref, so the "show bill of quantities" button finds it by id.
export const RESULTS_CARD_ID = "deck-designer-results";

// Switches several tabs, by URL parameter, in one navigation: one goToTab call each would start from
// the same search and the second would undo the first.
export type GoToTabs = (tabIndexByUrlParameter: Record<string, number>) => void;
